module.exports = __webpack_public_path__ + "static/media/icon_pet_services.15e54929.svg";